












import Component, {mixins} from "vue-class-component";
import {$t} from "@/lib/helpers/i18nHelper";
import {CheckAuthorities} from "@/lib/helpers/componentViewController/decorators";
import {FormFields, FormValues} from "@/types";
import PaymentSystemMixin from "@/views/PageSettingsPaymentSystems/mixins/PaymentSystemMixin";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBase from "@/components/BlockBase.vue";

@Component({
  name: "BlockPaymentSystemAddSelector",
  components: { BlockBaseForm, BlockBase },
})
export default class BlockPaymentSystemAddSelector extends mixins(PaymentSystemMixin) {
  @CheckAuthorities("PaymentSystem", "update_any")
  public hasAuthorities!: boolean;

  public get show() {
    return this.hasAuthorities;
  }

  get fields(): FormFields {
    return [
      {
        title: $t("Choose Payment System"),
        name: "paymentSystem",
        type: "select",
        value: this.systemList[0].value,
        list: this.systemList,
      },
    ];
  }

  public createSystem(values: FormValues) {
    const systemType = values["paymentSystem"] || this.systemList[0].value;
    this.$emit("create", { type: systemType });
  }
}
